import { z } from 'zod';
import { OfferSchema } from '~entities/offer/model/offer.contracts';

export const OccupancySchema = z.object({
  adults: z.number(),
  children: z.array(z.number()),
});

export const BookingRoomSchema = z.object({
  id: z.string().uuid(),
  offeringId: z.number().int().optional(),
  cartItemId: z.string().optional(),
  offer: OfferSchema,
  occupancy: OccupancySchema,
  // Optional pre-fill from /search/ deep-link, consumed by BookingCalendar to
  // seed its date range before the guest interacts with it.
  arrivalDay: z.string().optional(),
  nights: z.number().int().positive().optional(),
});
